export const metaInfo = {
  name: "sample-app",
  version: "5.0.2",
  type: "sample",
  platform: "React",
};
